import React from "react";
import ip from "../../IPinventory/css/ipInventory.module.scss";
import { DispensingLogStepperProps } from "../helpers/dispensing.types";

const DispensingLogStepper: React.FC<DispensingLogStepperProps> = ({
  currentStep,
  onStepChange,
  isStep2Enabled = true,
}) => {
  return (
    <div className={`card border-0 shadow-sm mb-4 ${ip.stepperCard}`}>
      <div className="d-flex align-items-center justify-content-between">
        {/* Step 1 Tab */}
        <div className={ip.stepTab} onClick={() => onStepChange(1)}>
          <div
            className={`${ip.stepCircle} ${
              currentStep === 1 ? ip.stepCircleActive : ip.stepCircleInactive
            }`}
          >
            <i className="ri-medicine-bottle-line"></i>
          </div>
          <span
            className={`${ip.stepLabel} ${
              currentStep === 1 ? ip.stepLabelActive : ip.stepLabelInactive
            }`}
          >
            Container Selection For Dispensing
          </span>
        </div>

        {/* Stepper Line */}
        <div className={ip.stepperLine}></div>

        {/* Step 2 Tab */}
        <div
          className={isStep2Enabled ? ip.stepTab : ip.stepTabDisabled}
          onClick={() => {
            if (isStep2Enabled) {
              onStepChange(2);
            }
          }}
        >
          <div
            className={`${ip.stepCircle} ${
              currentStep === 2 ? ip.stepCircleActive : ip.stepCircleInactive
            }`}
          >
            <i className="ri-checkbox-circle-line"></i>
          </div>
          <span
            className={`${ip.stepLabel} ${
              currentStep === 2 ? ip.stepLabelActive : ip.stepLabelInactive
            }`}
          >
            Dispensing Log Details
          </span>
        </div>
      </div>
    </div>
  );
};

export default DispensingLogStepper;
